var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Fragment } from "react";
import { FormControl, FormErrorMessage, FormLabel, Input, Select, } from "@reverb-ui/react";
import { FlexLine } from "../company-owner/flex-line";
import { RequiredIndicator } from "@/features/first-access/presentation/components/required-indicator";
import { Controller, } from "react-hook-form";
import { useTranslation } from "react-i18next";
export var ModalCompanyOwnerContactForm = function (_a) {
    var contact = _a.contact, index = _a.index, contactTypes = _a.contactTypes, countryCodes = _a.countryCodes, control = _a.control, register = _a.register, formErrors = _a.formErrors, isSubmitting = _a.isSubmitting;
    var t = useTranslation("my-account").t;
    var getErrorMessage = function (field) { var _a, _b, _c; return (_c = (_b = (_a = formErrors.contacts) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b[field]) === null || _c === void 0 ? void 0 : _c.message; };
    return (React.createElement(Fragment, { key: contact.contactId },
        React.createElement(FlexLine, { gap: "20px", h: undefined },
            React.createElement(FormControl, { isInvalid: getErrorMessage("contactType"), isDisabled: isSubmitting },
                React.createElement(FormLabel, null,
                    t("company-tab.modal-edit-contact.contact-type"),
                    " ",
                    React.createElement(RequiredIndicator, null)),
                React.createElement(Controller, { defaultValue: contact.contactType, name: "contacts." + index + ".contactType", control: control, rules: {
                        required: t("company-tab.modal-edit-contact.contact-type-required"),
                    }, render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(Select, __assign({}, field, { options: contactTypes, isDisabled: isSubmitting })));
                    } }),
                React.createElement(FormErrorMessage, null, getErrorMessage("contactType"))),
            React.createElement(FormControl, { isInvalid: getErrorMessage("firstName"), isDisabled: isSubmitting },
                React.createElement(FormLabel, null,
                    t("company-tab.modal-edit-contact.first-name"),
                    " ",
                    React.createElement(RequiredIndicator, null)),
                React.createElement(Input, __assign({}, register("contacts." + index + ".firstName", {
                    value: contact.firstName,
                    required: t("company-tab.modal-edit-contact.first-name-required"),
                }))),
                React.createElement(FormErrorMessage, null, getErrorMessage("firstName"))),
            React.createElement(FormControl, { isInvalid: getErrorMessage("lastName"), isDisabled: isSubmitting },
                React.createElement(FormLabel, null,
                    t("company-tab.modal-edit-contact.last-name"),
                    " ",
                    React.createElement(RequiredIndicator, null)),
                React.createElement(Input, __assign({}, register("contacts." + index + ".lastName", {
                    value: contact.lastName,
                    required: t("company-tab.modal-edit-contact.last-name-required"),
                }))),
                React.createElement(FormErrorMessage, null, getErrorMessage("lastName")))),
        React.createElement(FlexLine, { gap: "20px", h: undefined },
            React.createElement(FormControl, { isInvalid: getErrorMessage("email"), isDisabled: isSubmitting },
                React.createElement(FormLabel, null,
                    t("company-tab.modal-edit-contact.email"),
                    " ",
                    React.createElement(RequiredIndicator, null)),
                React.createElement(Input, __assign({}, register("contacts." + index + ".email", {
                    value: contact.email,
                    required: t("company-tab.modal-edit-contact.email-required"),
                }))),
                React.createElement(FormErrorMessage, null, getErrorMessage("email"))),
            React.createElement(FormControl, { isInvalid: getErrorMessage("countryCode"), isDisabled: isSubmitting },
                React.createElement(FormLabel, null,
                    t("company-tab.modal-edit-contact.country-code"),
                    React.createElement(RequiredIndicator, null)),
                React.createElement(Controller, { defaultValue: contact.countryCode, name: "contacts." + index + ".countryCode", control: control, rules: {
                        required: t("company-tab.modal-edit-contact.country-code-required"),
                    }, render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(Select, __assign({}, field, { options: countryCodes, isDisabled: isSubmitting })));
                    } }),
                React.createElement(FormErrorMessage, null, getErrorMessage("countryCode"))),
            React.createElement(FormControl, { isInvalid: getErrorMessage("phoneNumber"), isDisabled: isSubmitting },
                React.createElement(FormLabel, null,
                    t("company-tab.modal-edit-contact.phone-number"),
                    " ",
                    React.createElement(RequiredIndicator, null)),
                React.createElement(Input, __assign({}, register("contacts." + index + ".phoneNumber", {
                    value: contact.phoneNumber,
                    required: t("company-tab.modal-edit-contact.phone-number-required"),
                }))),
                React.createElement(FormErrorMessage, null, getErrorMessage("phoneNumber"))))));
};
